/* eslint-disable */
import Vue from 'vue'
import moment from 'moment';

Vue.filter('dateformat', (arg) => {
  return moment(arg).format('MMMM Do YYYY')
})
Vue.filter('secondDateFormat', (arg) => {
  return moment(arg).format('DD MMMM YYYY')
})
Vue.filter('timeformat', (arg) => {
  return moment(arg).format('h:mm:ss a')
})
Vue.filter('secondTimeFormat', (arg) => {
  return moment(arg).format('h:mm A')
})
Vue.filter('UtcDateFormat', (arg) => {
  return moment(arg).utc().format('MMMM DD YYYY')
})
Vue.filter('UtcTimeFormat', (arg) => {
  return moment(arg).utc().format('h:mm:ss a')
})